'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'balloons';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e2e4';
var svgPathData = 'M182.9 346.8s0 0 0 0c0 0 0 0 0 0l.2-.1 .9-.7c.8-.6 2.1-1.5 3.8-2.8c3.3-2.5 8.1-6.2 13.9-11c11.6-9.6 26.9-23.6 42.3-40.8c31.1-35 60-81.3 60-131.4c0-79.5-64.5-144-144-144S16 80.5 16 160c0 50.1 28.8 96.4 60 131.4c15.3 17.3 30.7 31.2 42.3 40.8c5.8 4.8 10.6 8.5 13.9 11c1.7 1.2 2.9 2.2 3.8 2.8l.9 .7 .2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0l7.5 5.2 30.8 0 7.5-5.2s0 0 0 0s0 0 0 0zM118.8 432l82.3 0-23.3-64-1.9 0-32 0-1.9 0-23.3 64zm99.3 0l5.8 16-17 0-94 0-17 0 5.8-16L128 360s-128-88-128-200C0 71.6 71.6 0 160 0s160 71.6 160 160c0 112-128 200-128 200l26.2 72zM324.7 261.8c4.3-8.2 8.3-16.8 11.8-25.6c4.1 45.4 30.8 87.1 59.4 119.2c15.3 17.3 30.7 31.2 42.3 40.8c5.8 4.8 10.6 8.5 13.9 11c1.7 1.2 2.9 2.2 3.8 2.8l.9 .7 .2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0l7.5 5.2 30.8 0 7.5-5.2s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1 .9-.7c.9-.6 2.1-1.5 3.8-2.8c3.3-2.5 8.1-6.2 13.9-11c11.6-9.6 26.9-23.6 42.3-40.8c31.1-35 60-81.3 60-131.4c0-79.5-64.5-144-144-144c-55.7 0-104.1 31.7-128 78c-.1-9.2-.8-18.2-2.2-27c29-40.5 76.5-67 130.2-67c88.4 0 160 71.6 160 160c0 112-128 200-128 200l26.2 72 5.8 16-17 0-94 0-17 0 5.8-16L448 424s-100.1-68.8-123.3-162.2zM462.1 432l-23.3 64 82.3 0-23.3-64-1.9 0-32 0-1.9 0zM96 152l0 8-16 0 0-8c0-39.8 32.2-72 72-72l8 0 0 16-8 0c-30.9 0-56 25.1-56 56zm320 64l0 8-16 0 0-8c0-39.8 32.2-72 72-72l8 0 0 16-8 0c-30.9 0-56 25.1-56 56z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBalloons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;